/* Sticky collection filter sits below the stuck header (#54). */
(function () {
  function place() {
    var filter = document.querySelector('.collection-filter');
    if (!filter) return;

    var mobile = window.matchMedia('(max-width: 768px)').matches;
    if (!mobile) {
      if (filter.dataset.leveretFilterTop === '1') {
        filter.style.top = '';
        delete filter.dataset.leveretFilterTop;
      }
      return;
    }

    var stuck = document.querySelector('.site-header--stuck');
    var top = 0;
    if (stuck) {
      var height = Math.round(stuck.getBoundingClientRect().height);
      if (height > 0) top = height;
    }
    filter.style.top = top + 'px';
    filter.dataset.leveretFilterTop = '1';
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      place();
    });
  }

  function boot() {
    place();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      schedule();
      window.setTimeout(schedule, 600);
    });
    document.addEventListener('collection:reloaded', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Load the next collection page into the same grid. First paint stays one paginate. */
(function () {
  var NEAR = 800;
  var DEFAULT_SORT = 'best-selling';
  var session = 0;
  var observer = null;
  var controller = null;
  var sortAligned = false;
  var alignToken = 0;

  function pageNumber(url) {
    var value = new URL(url, window.location.origin).searchParams.get('page');
    var number = parseInt(value || '1', 10);
    return number > 0 ? number : 1;
  }

  function withCurrentFilters(url) {
    var next = new URL(url, window.location.origin);
    var current = new URL(window.location.href);
    var seen = {};
    current.searchParams.forEach(function (value, key) {
      if (key === 'page' || key === 'section_id' || seen[key]) return;
      seen[key] = true;
      if (next.searchParams.has(key)) return;
      current.searchParams.getAll(key).forEach(function (item) {
        next.searchParams.append(key, item);
      });
    });
    next.searchParams.delete('section_id');
    if (!next.hash && current.hash) next.hash = current.hash;
    return next;
  }

  function ensureSort(url) {
    if (!url.searchParams.get('sort_by')) url.searchParams.set('sort_by', DEFAULT_SORT);
    return url;
  }

  function publicUrl(url) {
    var copy = new URL(url.toString());
    copy.searchParams.delete('section_id');
    if (copy.searchParams.get('sort_by') === DEFAULT_SORT) copy.searchParams.delete('sort_by');
    return copy.pathname + copy.search + copy.hash;
  }

  function storageKey() {
    var copy = new URL(window.location.href);
    copy.searchParams.delete('section_id');
    copy.searchParams.delete('page');
    if (copy.searchParams.get('sort_by') === DEFAULT_SORT) copy.searchParams.delete('sort_by');
    return copy.pathname + copy.search;
  }

  function readMemory() {
    try {
      var data = JSON.parse(sessionStorage.getItem('leveret-collection-chunks') || 'null');
      if (!data || data.key !== storageKey()) return null;
      return data;
    } catch (err) {
      return null;
    }
  }

  function remember(page) {
    try {
      var prior = readMemory();
      var storedPage = prior && prior.page > page ? prior.page : page;
      var storedY = arguments.length > 1 ? arguments[1] : (prior ? prior.y : 0);
      sessionStorage.setItem('leveret-collection-chunks', JSON.stringify({
        key: storageKey(),
        page: storedPage,
        y: storedY || 0
      }));
    } catch (err) {}
  }

  function shouldAlignSort() {
    if (new URLSearchParams(window.location.search).has('sort_by')) return false;
    var select = document.querySelector('#SortBy');
    if (!select) return false;
    return (select.getAttribute('data-collection-sort') || '') !== DEFAULT_SORT;
  }

  function alignSort(token, done) {
    var section = document.querySelector('[data-section-type="collection-grid"]');
    var sectionId = section && section.getAttribute('data-section-id');
    if (!sectionId) { done(); return; }
    var target = ensureSort(withCurrentFilters(window.location.href));
    target.searchParams.set('section_id', sectionId);
    fetch(target.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('status ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (token !== alignToken) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var source = parsed.querySelector('[data-leveret-product-grid]');
        var live = document.querySelector('[data-leveret-product-grid]');
        if (source && live) live.innerHTML = source.innerHTML;
        var more = parsed.querySelector('[data-leveret-pages]');
        var livePages = document.querySelector('[data-leveret-pages]');
        if (more && livePages) {
          livePages.innerHTML = more.innerHTML;
          livePages.setAttribute('data-current-page', more.getAttribute('data-current-page') || '');
          livePages.setAttribute('data-page-count', more.getAttribute('data-page-count') || '');
        }
      })
      .catch(function () {})
      .then(function () {
        if (token !== alignToken) return;
        done();
      });
  }

  function nextLink(root) {
    var link = root && root.querySelector('.pagination .next a');
    return link ? link.href : '';
  }

  function isPromo(node) {
    return !!(node && node.classList && (
      node.classList.contains('leveret-native-promo') ||
      node.classList.contains('leveret-bundle-tile') ||
      (node.querySelector && node.querySelector('.leveret-promo-tile'))
    ));
  }

  function cardKey(node) {
    var link = node.querySelector && node.querySelector('a.grid-product__link');
    if (link) return link.getAttribute('href') || '';
    return node.getAttribute ? (node.getAttribute('data-product-id') || '') : '';
  }

  function bindQuickShop(nodes) {
    if (!window.theme || !theme.settings || !theme.settings.quickView || typeof theme.preloadProductModal !== 'function') return;
    nodes.forEach(function (node) {
      if (!node.classList || !node.classList.contains('grid-product')) return;
      if (node.dataset.leveretQuickBound === '1') return;
      node.dataset.leveretQuickBound = '1';
      function enter(event) {
        var el = event.currentTarget;
        if (theme.config && theme.config.bpSmall) return;
        el.removeEventListener('mouseover', enter);
        el.removeEventListener('focusin', enter);
        if (!el.dataset.productId) return;
        theme.preloadProductModal(el.dataset.productHandle, el.dataset.productId, el.querySelector('.quick-product__btn'));
      }
      node.addEventListener('mouseover', enter);
      node.addEventListener('focusin', enter);
    });
  }

  function reinitCards(nodes) {
    bindQuickShop(nodes);
    if (window.LeveretHolidayCards && typeof LeveretHolidayCards.bindCardAdds === 'function') {
      LeveretHolidayCards.bindCardAdds(document);
    }
    if (window.AOS && typeof AOS.refreshHard === 'function') AOS.refreshHard();
    if (window.lazySizes && lazySizes.loader && typeof lazySizes.loader.checkElems === 'function') {
      lazySizes.loader.checkElems();
    }
    nodes.forEach(function (node) {
      node.querySelectorAll('.opinew-stars-plugin-product-list').forEach(function (stars) {
        stars.removeAttribute('data-opw-initialized');
      });
    });
    if (window.opw && typeof window.opw.initProductListStars === 'function') {
      window.opw.initProductListStars(document);
    }
    document.dispatchEvent(new CustomEvent('leveret:collection-chunk', { detail: { nodes: nodes } }));
  }

  function skeleton(grid) {
    var sample = grid.querySelector('.grid-product:not(.leveret-chunk-skeleton) .grid__image-ratio');
    var ratioName = 'grid__image-ratio';
    if (sample) {
      ratioName = Array.prototype.filter.call(sample.classList, function (name) {
        return name.indexOf('grid__image-ratio') === 0;
      }).join(' ') || ratioName;
    }
    var node = document.createElement('div');
    node.className = 'grid__item grid-product leveret-chunk-skeleton small--one-half medium-up--one-quarter';
    node.setAttribute('aria-hidden', 'true');
    var content = document.createElement('div');
    content.className = 'grid-product__content';
    var mask = document.createElement('div');
    mask.className = 'grid-product__image-mask';
    var ratio = document.createElement('div');
    ratio.className = ratioName;
    mask.appendChild(ratio);
    var meta = document.createElement('div');
    meta.className = 'grid-product__meta';
    var bar = document.createElement('div');
    bar.className = 'leveret-chunk-skeleton__bar';
    var shortBar = document.createElement('div');
    shortBar.className = 'leveret-chunk-skeleton__bar leveret-chunk-skeleton__bar--short';
    meta.appendChild(bar);
    meta.appendChild(shortBar);
    content.appendChild(mask);
    content.appendChild(meta);
    node.appendChild(content);
    return node;
  }

  function boot() {
    session += 1;
    var run = session;
    if (controller) controller.abort();
    if (observer) observer.disconnect();
    observer = null;
    controller = null;

    if (window.Shopify && window.Shopify.designMode) {
      document.documentElement.classList.remove('leveret-chunks');
      return;
    }

    if (!sortAligned && shouldAlignSort()) {
      sortAligned = true;
      alignToken += 1;
      var token = alignToken;
      var alignRun = run;
      alignSort(token, function () {
        if (alignRun !== session) return;
        boot();
      });
      return;
    }

    var pages = document.querySelector('[data-leveret-pages]');
    var grid = document.querySelector('[data-leveret-product-grid]');
    var foot = document.querySelector('[data-leveret-chunk-foot]');
    var status = document.querySelector('[data-leveret-chunk-status]');
    if (!pages || !grid || !foot || !status) return;
    grid.querySelectorAll('.leveret-chunk-skeleton').forEach(function (node) { node.remove(); });

    var section = pages.closest('[data-section-id]');
    var sectionId = section && section.getAttribute('data-section-id');
    var upcoming = nextLink(pages);
    if (!sectionId || !upcoming) {
      document.documentElement.classList.remove('leveret-chunks');
      return;
    }

    document.documentElement.classList.add('leveret-chunks');
    var seenPages = {};
    var lastLoaded = pageNumber(window.location.href);
    seenPages[lastLoaded] = true;
    var busy = false;

    function reveal(message) {
      var failed = upcoming;
      document.documentElement.classList.remove('leveret-chunks');
      status.textContent = message || '';
      if (failed && pages) {
        var next = pages.querySelector('.pagination .next a');
        if (next) {
          var wrap = next.parentNode;
          if (wrap) wrap.hidden = false;
          next.setAttribute('href', publicUrl(ensureSort(new URL(failed, window.location.origin))));
        }
        pages.querySelectorAll('.pagination a').forEach(function (anchor) {
          if (anchor === next) return;
          var n = pageNumber(anchor.href);
          if (n && n <= lastLoaded && anchor.parentNode) anchor.parentNode.hidden = true;
        });
      }
      upcoming = '';
    }

    function clearSkeletons() {
      grid.querySelectorAll('.leveret-chunk-skeleton').forEach(function (node) {
        node.remove();
      });
    }

    function nearFoot() {
      return foot.getBoundingClientRect().top < window.innerHeight + NEAR;
    }

    function loadNext(done) {
      if (run !== session || busy || !upcoming) {
        if (typeof done === 'function') done();
        return;
      }
      var page = pageNumber(upcoming);
      if (seenPages[page]) return;
      seenPages[page] = true;
      busy = true;
      status.textContent = 'Loading more products';
      foot.classList.add('is-loading');
      grid.setAttribute('aria-busy', 'true');
      for (var i = 0; i < 4; i++) grid.appendChild(skeleton(grid));
      var target = ensureSort(withCurrentFilters(upcoming));
      target.searchParams.set('section_id', sectionId);
      controller = new AbortController();
      var signal = controller.signal;

      fetch(target.toString(), { credentials: 'same-origin', signal: signal })
        .then(function (response) {
          if (!response.ok) throw new Error('status ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (run !== session) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var source = parsed.querySelector('[data-leveret-product-grid]');
          var more = parsed.querySelector('[data-leveret-pages]');
          var keepPromo = !grid.querySelector('.leveret-native-promo, .leveret-bundle-tile, .leveret-promo-tile');
          var known = {};
          grid.querySelectorAll('a.grid-product__link').forEach(function (link) {
            known[link.getAttribute('href')] = true;
          });
          var added = [];
          if (source) {
            Array.prototype.forEach.call(source.children, function (node) {
              if (!node.classList || !node.classList.contains('grid__item')) return;
              if (node.classList.contains('leveret-chunk-skeleton')) return;
              if (isPromo(node) && !keepPromo) return;
              var key = cardKey(node);
              if (key && known[key]) return;
              if (key) known[key] = true;
              if (isPromo(node)) keepPromo = false;
              added.push(node);
            });
          }
          if (!source) {
            clearSkeletons();
            reveal('Couldn\u2019t load more products.');
            return;
          }
          var anchor = grid.querySelector('.leveret-chunk-skeleton');
          added.forEach(function (node) {
            grid.insertBefore(node, anchor);
          });
          clearSkeletons();
          if (!added.length) {
            upcoming = more ? nextLink(more) : '';
            return;
          }
          reinitCards(added);
          lastLoaded = page;
          remember(lastLoaded);
          upcoming = more ? nextLink(more) : '';
          status.textContent = upcoming ? '' : '';
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (run !== session) return;
          clearSkeletons();
          reveal('Couldn\u2019t load more products.');
        })
        .finally(function () {
          if (run !== session) return;
          busy = false;
          grid.removeAttribute('aria-busy');
          foot.classList.remove('is-loading');
          if (typeof done === 'function') {
            done();
            return;
          }
          if (!upcoming) {
            status.textContent = status.textContent || '';
            if (observer) observer.disconnect();
            return;
          }
          status.textContent = '';
          if (nearFoot()) loadNext();
        });
    }

    function arm() {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) loadNext();
      }, { rootMargin: '0px 0px ' + NEAR + 'px 0px' });
      observer.observe(foot);
    }

    var memory = readMemory();
    var here = pageNumber(window.location.href);
    if (memory && !new URLSearchParams(window.location.search).has('page') && memory.page > here && upcoming) {
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
      (function pump() {
        if (run !== session || !upcoming || pageNumber(upcoming) > memory.page) {
          window.requestAnimationFrame(function () {
            window.scrollTo(0, memory.y || 0);
          });
          arm();
          return;
        }
        loadNext(pump);
      })();
      return;
    }

    remember(here, window.scrollY || 0);
    arm();
  }

  var scrollTick = false;
  window.addEventListener('scroll', function () {
    if (scrollTick) return;
    scrollTick = true;
    window.requestAnimationFrame(function () {
      scrollTick = false;
      var data = readMemory();
      if (!data) return;
      remember(data.page, window.scrollY || 0);
    });
  }, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('collection:reloaded', function () {
    sortAligned = false;
    alignToken += 1;
    boot();
  });
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (target && target.querySelector && target.querySelector('[data-leveret-pages]')) {
      sortAligned = false;
      alignToken += 1;
      boot();
    }
  });
})();
